import { render, staticRenderFns } from "./AbsaPayBankForm.vue?vue&type=template&id=64f8a630&scoped=true"
import script from "./AbsaPayBankForm.vue?vue&type=script&lang=js"
export * from "./AbsaPayBankForm.vue?vue&type=script&lang=js"
import style0 from "./AbsaPayBankForm.vue?vue&type=style&index=0&id=64f8a630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8a630",
  null
  
)

export default component.exports